<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6">
                        <img class="back-icon" @click="closeVue" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">共享空间</div>
                    </van-col>
                    <van-col span="6">
                        <div class="right-box">
                            <img v-if="friendList.length == 0 && newFriendCount == 0" @click="toAdd" class="banner-add"
                                 src="@/assets/theme/light/share/01home/01add.svg">
                            <img v-if="friendList.length > 0 || newFriendCount > 0" @click="toFriendList"
                                 class="banner-add"
                                 src="@/assets/theme/light/share/01home/03friend.svg">
                            <img @click="toQr" class="qr-code" src="@/assets/theme/light/share/01home/02qr.svg">
                            <div class="new-bar" v-if="newFriendCount > 0"></div>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-body">
            <div class="no-friend" v-if="friendList.length == 0 && !loading">
                <img class="no-img" src="@/assets/theme/light/share/01home/05no.svg">
                <div class="no-text">邀请TA加入共享空间，分享健康和运动</div>
            </div>
            <div class="friend-box" v-if="friendList.length != 0 && !loading">
                <div class="own">
                    <img class="own-icon" :src="own.userAvatar ? own.userAvatar : defaultImg">
                </div>
                <div class="friend" v-for="item in friendList.slice(0, 5)">
                    <img class="friend-icon" @click="toFriendDesc(item.userId)"
                         :src="item.userAvatar ? item.userAvatar : defaultImg">
                </div>
                <div class="other-num" v-if="friendList.length > 5">+{{friendList.length}}</div>
                <div class="add-box">
                    <img @click="toAdd" class="add-icon"
                         :src="require(`@/assets/theme/${theme}/share/01home/04add.svg`)">
                </div>
            </div>
            <div class="rank-box" v-if="friendList.length != 0">
                <img class="rank" @click="toSportRank" src="@/assets/theme/light/share/01home/06bg.png">
                <div class="target-box">
                    <img class="target-bg" :src="require(`@/assets/theme/${theme}/share/01home/07bg.png`)">
                    <div class="complete-num"><span class="c-num">{{completeNum}}</span><span class="nc-num">/2</span>
                    </div>
                    <div class="step-num"><span class="st-num">{{step.current}}</span><span
                            class="nc-num">/{{step.target}}</span></div>
                    <div class="cal-num"><span class="ca-num">{{cal.current}}</span><span
                            class="nc-num">/{{cal.target}}</span></div>
                    <div class="progress step-progress">
                        <div v-if="step.current" class="progress-bar progress-bar-striped"
                             :style="{'width': stepRatio}"></div>
                    </div>
                    <div class="progress step-progress">
                        <div v-if="step.current" class="progress-bar progress-bar-info"
                             :style="{'width': stepRatio}"></div>
                    </div>
                    <div class="progress cal-progress">
                        <div v-if="cal.current" class="progress-bar progress-bar-striped"
                             :style="{'width': calRatio}"></div>
                    </div>
                    <div class="progress cal-progress">
                        <div v-if="cal.current" class="progress-bar progress-bar-info-cal"
                             :style="{'width': calRatio}"></div>
                    </div>
                </div>
                <div class="unread-box-margin" v-if="unReadCount > 0" @click="toUnRead">
                    <div class="unread-box">
                        <img class="unread-icon" :src="latestFriend ? latestFriend : defaultImg">
                        <span class="unread-msg">{{unReadCount > 99 ? '99+' : unReadCount }} 条新消息</span>
                    </div>
                </div>
            </div>
            <div class="dynamics">
                <div class="d-item" v-for="(item, i) in dynamicList">
                    <div class="d-top">
                        <img @click="toFriendDesc(item.userId)" class="d-avatar"
                             :src="item.userAvatar ? item.userAvatar : defaultImg">
                        <div class="d-info">
                            <div class="d-username" @click="toFriendDesc(item.userId)">{{item.userNameRemark ?
                                item.userNameRemark : item.userName}}
                            </div>
                            <div class="d-time">{{item.createTime}}</div>
                        </div>
                    </div>
                    <div class="d-sport" v-if="item.sportId" @click="openDynamicDesc(item)">
                        <div class="d-sport-type">{{item.sportType}}</div>
                        <div class="d-sport-info">{{(item.distance / 100000).toFixed(2)}}<span class="d-unit">公里</span>
                            <img class="d-sport-time" src="@/assets/theme/light/share/01home/08time.png">
                            {{formatSeconds3(item.actTime)}}
                        </div>
                        <img class="d-sport-icon" :src="require(`@/assets/share/home/${item.sportType}.svg`)">
                    </div>
                    <div class="d-ecg" v-if="item.ecgId" @click="openDynamicDesc(item)">
                        <van-row>
                            <van-col span="14">
                                <div class="d-ecg-left">
                                    <div class="ecg-info">
                                        <div v-if="!item.isError" class="ecg-normal"></div>
                                        <div v-if="item.isError" class="ecg-error"></div>
                                        <div class="ecg-conclusion">{{item.conclusion}}</div>
                                    </div>
                                    <div class="ecg-from">由<span class="ecg-add">{{item.deviceName}}</span>采集</div>
                                </div>
                            </van-col>
                            <div class="ecg-chart" :id="item.ecgId"></div>
                        </van-row>
                    </div>
                    <div class="d-bottom">
                        <van-row>
                            <van-col span="12">
                                <div class="d-b-item d-b-item-left">
                                    <img v-if="item.isLike" class="d-b-icon"
                                         src="@/assets/theme/light/share/01home/09liked.svg"
                                         @click="like(item, 0)">
                                    <img v-if="!item.isLike" class="d-b-icon"
                                         src="@/assets/theme/light/share/01home/09like.svg"
                                         @click="like(item, 1)">
                                    <span class="like-num">{{item.likeNum == 0 ? '赞' : item.likeNum}}</span>
                                </div>
                            </van-col>
                            <van-col span="12" @click="clickComment(item, '', 0, item.userId)">
                                <div class="d-b-item">
                                    <img class="d-b-icon" src="@/assets/theme/light/share/01home/10commit.svg">
                                    <span class="comment-num">{{item.commentList.length > 0 ? item.commentList.length : '评论'}}</span>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <div class="d-comment" v-if="item.commentList.length > 0">
                        <div class="d-comment-box">
                            <div class="d-comment-item"
                                 @click="clickComment(item, c, 1, c.userId)"
                                 v-for="(c, index) in item.commentList" v-show="index < 3 || item.isent">
                            <span @click="toFriendDesc(c.userId)">
                            <img class="comment-avatar" :src="c.userAvatar ? c.userAvatar : defaultImg">
                                <span class="comment-username">{{c.userNameRemark ? c.userNameRemark : c.userName}}</span></span>
                                <span v-if="c.type == 1">
                                <span style="margin-left: 4px">回复</span>
                                <span class="comment-username"
                                      @click="toFriendDesc(c.toUserId)">{{c.toUserNameRemark ? c.toUserNameRemark : c.toUserName}}：</span>
                            </span>
                                <span v-if="c.type == 0" class="comment-username">：</span>
                                {{c.content}}
                            </div>
                            <div class="all-btn" v-show="item.commentList.length > 3" @click="openHide(item)">
                                {{item.isent ?
                                '收起' : '查看所有评论'}}>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="load-more" @click="loadMore()" v-if="pageSize * pageNum > count && count > 0">点击加载更多</div>
                <van-popup v-model="showComment" position="bottom" style="background: #F3F3F3">
                    <div class="apply-value">
                        <van-field v-model="commentInfo.content" :placeholder="commentInfo.type == 0 ? '评论':'回复'">
                            <template #button>
                                <van-button size="mini" type="primary" @click="sendComment"
                                            :disabled="commentInfo.content.length == 0">发送
                                </van-button>
                            </template>
                        </van-field>
                    </div>
                </van-popup>
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable} from '@/utils/comment'
    import {SwitchTime, SwitchTimeToM, GetMonthStr, getMonthStartDay, formatSeconds3} from '@/utils/dateUtils'
    import {Toast} from 'vant'
    import gpsBaidu from "../../components/gpsBaidu";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'home',
        components: {
            gpsBaidu
        },
        data() {
            return {
                theme: 'light',
                loading: true,
                defaultImg: require('@/assets/share/home/noImg.png'),
                friendList: [],
                own: {},
                step: {},
                cal: {},
                unReadCount: 0,
                latestFriend: '',
                completeNum: 0,
                stepRatio: '0%',
                calRatio: '%',
                count: 0,
                pageSize: 10,
                pageNum: 0,
                dynamicList: [],
                isLoading: false,
                showComment: false,
                currentD: {}, // 当前动态
                commentInfo: {}, // 评论内容
                websocket: {},
                newFriendCount: 0,
                getTag: 0, // 获取月份tag，本月0， 上月1
                startTime: getMonthStartDay(0), // 获取动态列表开始时间
                endTime: GetMonthStr(0) + ' 23:59:59', // 获取动态列表结束时间
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.getHome();
            this.getDynamicsList();
            this.bindScroll();
            this.initWebSocket();
            this.getAPPDate();
        },
        methods: {
            loadMore() {
                this.getTag += 1;
                this.startTime = getMonthStartDay(-this.getTag);
                this.endTime = GetMonthStr(this.getTag) + ' 23:59:59';
                this.count = 0;
                this.pageNum = 0;
                this.getDynamicsList();
            },
            getAPPDate() {
                console.log('getAPPDate')
                this.$bridgeObj.registerHandler('jsBrigeReq', (data, responseCallback) => {
                    alert('app主动调用js方法，传入数据:' + data)
                    responseCallback(data)
                })
            },
            closeVue() {
                console.log('WebJSBridge.call("closeWeb"..')
                WebJSBridge.call("closeWeb", null, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            openDynamicDesc(item) {
                WebJSBridge.call("openDynamicDesc", {
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    userAvatar: item.userAvatar,
                    startSportTime: item.createTime
                }, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            testTwo() {
                this.$bridgeObj.callHandler('jsBrigeTest', "js调用APP方法", (data) => {
                    alert('js调用APP方法，收到数据:' + data)
                })
            },
            initWebSocket() {
                console.log('initWebSocket方法')
                // 根据自己的方法获取userCode
                let userCode = localStorage.getItem('userId')
                // WebSocket地址为接口地址，http用ws、https用wws
                let url;
                if (window.location.hostname.indexOf('localhost') != -1) {
                    url = 'ws://localhost:5443/bdwatch_service/webSocket/' + userCode;
                } else if (window.location.pathname.indexOf('debug') != -1) {
                    url = 'wss://124.71.143.120:443/v_t/websocket/' + userCode;
                } else {
                    url = 'wss://124.71.143.120:443/v_f/websocket/' + userCode;
                }
                this.websocket = new WebSocket(url)
                this.websocket.onopen = this.webSocketOpen
                this.websocket.onerror = this.webSocketError
                this.websocket.onmessage = this.webSocketMessage
                this.websocket.onclose = this.webSocketClose
            },
            webSocketOpen() {
                console.log('WebSocket连接成功')
            },
            webSocketError() {
                console.log('WebSocket连接错误')
            },
            webSocketMessage(e) {
                // 接收服务器返回的数据
                if (e.data.indexOf('新动态') != -1) {
                    this.unReadCount += 1;
                    let userAvatar = e.data.split(',')[1];
                    if (userAvatar && userAvatar != 'null') {
                        this.latestFriend = userAvatar;
                    } else {
                        this.latestFriend = this.defaultImg;
                    }
                }
                console.log('服务器返回的消息', e.data)
            },
            webSocketClose(e) {
                console.log('WebSocket连接断开', e)
            },
            getHome() {
                this.$api.share.getHome().then(res => {
                    this.newFriendCount = res.info.newFriendCount;
                    this.loading = false
                    let info = res.info
                    this.friendList = info.friendList;
                    this.own = info.own;
                    localStorage.setItem("userId", this.own.userId);
                    localStorage.setItem("userAvatar", this.own.userAvatar ? this.own.userAvatar : this.defaultImg);
                    localStorage.setItem("userName", this.own.userName);
                    if (this.own.userArea) {
                        localStorage.setItem("userArea", this.own.userArea);
                    } else {
                        localStorage.setItem("userArea", '北京');
                    }
                    this.step = info.step;
                    this.cal = info.cal;
                    this.unReadCount = info.unReadCount;
                    this.latestFriend = info.latestFriend;
                    this.completeNum = 0;
                    this.stepRatio = '0%';
                    this.calRatio = '0%';
                    if (this.step.current) {
                        this.stepRatio = this.step.current / this.step.target > 1 ? '100%' : this.step.current / this.step.target * 100 + '%';
                        if (this.step.current > this.step.target) {
                            this.completeNum++;
                        }
                    }
                    if (this.cal.current) {
                        this.calRatio = this.cal.current / this.cal.target > 1 ? '100%' : this.cal.current / this.cal.target * 100 + '%';
                        if (this.cal.current > this.cal.target) {
                            this.completeNum++;
                        }
                    }
                })
            },
            getDynamicsList() {
                this.pageNum++;
                this.isLoading = true;
                this.$api.share.getDynamicsList({
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    startTime: this.startTime,
                    endTime: this.endTime
                }).then(res => {
                    this.count = res.info.count;
                    this.dynamicList.push(...res.info.items);
                    this.isLoading = false;
                    for (let i = 0; i < res.info.items.length; i++) {
                        if (res.info.items[i].ecgId && res.info.items[i].ecgFragment) {
                            this.$nextTick(function () {
                                this.drawEcg(res.info.items[i])
                            })
                        }
                    }
                })
            },
            // 滚动回调函数
            scrollHande() {
                // 节流
                if (this.isLoading) return
                // 获取内容高度
                var scrollH = document.documentElement.scrollHeight
                // 获取窗口高度
                var innerH = window.innerHeight
                // 获取滚出去的内容高度
                var top = document.body.scrollTop || document.documentElement.scrollTop
                // 当内容还剩余200的高度未滚出的时候发送请求
                if (scrollH - top - innerH < 200) {
                    // 发送请求
                    this.getDynamicsList();
                }
            },
            // 绑定scroll事件
            bindScroll() {
                window.addEventListener('scroll', this.scrollHande)
            },
            // 清除scroll事件
            clearScroll() {
                window.removeEventListener('scroll', this.scrollHande)
            },
            toQr() {
                this.$router.push({
                    name: 'myQrLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toAdd() {
                this.$router.push({
                    name: 'addFriendLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toFriendList() {
                this.$router.push({
                    name: 'friendListLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toSportRank() {
                this.$router.push({
                    name: 'sportRankLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toFriendDesc(userId) {
                if (userId != localStorage.getItem("userId")) {
                    localStorage.setItem("sharerId", userId);
                    this.$router.push({
                        name: 'friendDescLight',
                        query: {
                            theme: this.theme
                        }
                    })
                }
            },
            checkPower(sportType) {
                let tag = 0;
                if (sportType == '自由训练' || sportType == '俯卧撑' || sportType == '深蹲' || sportType == '卷腹' || sportType == '平板支撑' || sportType == '椭圆机' || sportType == '划船机' || sportType == '跳绳') {
                    tag = 1;
                }
                return tag;
            },
            dealTime(n) {
                return SwitchTime(n);
            },
            dealSwolf(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let swolf = item.avgSwolf;
                if (is806) {
                    swolf = parseInt(swolf / 10)
                }
                return swolf;
            },
            dealPach(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let value = item.avgSpeed;
                if (!is806 && (item.sportType != '室内游泳')) {
                    value = value == 0 ? 0 : 10000 / (value ? value : 1);
                }
                if (!is806 && (item.sportType == '室内游泳')) {
                    value = value == 0 ? 0 : 1000 / (value ? value : 1);
                }
                return SwitchTimeToM(value);
            },
            clickComment(item, c, type, toUserId) {
                this.currentD = item;
                this.commentInfo = {
                    ecgId: item.ecgId,
                    sportType: item.sportType,
                    sportId: item.sportId,
                    startSportTime: item.createTime,
                    type: type,
                    toUserId,
                    content: '',
                    userId: localStorage.getItem('userId'),
                    userAvatar: localStorage.getItem('userAvatar').indexOf('http') != -1 ? localStorage.getItem('userAvatar') : '',
                    userName: localStorage.getItem('userName'),
                    toUserName: c ? (c.userNameRemark ? c.userNameRemark : c.userName) : ''
                }
                this.showComment = true;
            },
            sendComment() {
                this.$api.share.comment(this.commentInfo).then(res => {
                    this.currentD.commentList.push(this.commentInfo);
                    this.$set(this.currentD, 'commentList', this.currentD.commentList);
                    this.showComment = false;
                    this.commentInfo = {}
                }).catch(e => {
                    Toast({message: '发言不符合社区规范！'});
                })
            },
            openHide(item) {
                this.$set(item, 'isent', !item.isent)
            },
            like(item, isLike) {
                this.$api.share.like({
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    startSportTime: item.createTime,
                    isLike,
                    toUserId: item.userId
                }).then(res => {
                    this.$set(item, 'isLike', isLike);
                    if (isLike) {
                        this.$set(item, 'likeNum', item.likeNum + 1);
                    } else {
                        this.$set(item, 'likeNum', item.likeNum - 1);
                    }
                })
            },
            drawEcg(item) {
                let a = item.ecgFragment;
                let b = a.split(',');
                let c = [];
                for (let i = 0; i < b.length; i++) {
                    c.push(i);
                }
                let myChart = this.$echarts.init(document.getElementById(item.ecgId));
                myChart.setOption({
                    grid: {
                        top: 0,
                        bottom: 0,
                        left: 10,
                        right: 10
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: c
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            data: b,
                            type: 'line',
                            symbol: 'none',
                            color: '#FF0101',
                            smooth: false,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            },
            toUnRead() {
                this.$router.push({
                    name: 'unReadListLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            formatSeconds3(m) {
                return formatSeconds3(m)
            }
        },
        // 页面销毁之前，清除scroll
        destroyed() {
            this.clearScroll();
        }
    }
</script>

<style scoped>
    @import "../../assets/font/font.css";

    .no-friend {
        text-align: center;
    }

    .no-img {
        width: 259px;
        margin-top: 20px;
    }

    .no-text {
        margin-top: 20px;
        font-size: 15px;
        color: var(--text-color-1);
        margin-bottom: 30px;
    }

    .dynamics {
        margin: 0px 15px;
    }

    .d-item {
        width: 100%;
        background: var(--bg-color-2);
        margin-bottom: 10px;
        border-radius: 6px;
        padding-bottom: 6px;
    }

    .d-avatar {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        border: 2px solid var(--text-color-1);
        margin: 14px 10px 15px 17px;
        vertical-align: top;
    }

    .d-info {
        display: inline-block;
        margin-top: 14px;
    }

    .d-username {
        opacity: 0.9;
        font-size: 14px;
        line-height: 24px;
        color: var(--text-color-1);
    }

    .d-time {
        opacity: 0.4;
        font-size: 12px;
        color: var(--text-color-1);
    }

    .icon-box {
        width: 56px;
        height: 56px;
        border-radius: 4px;
        background: var(--text-color-1);
        border: 1px solid #343434;
        margin: 12px 10px 10px 15px;
        display: inline-block;
        vertical-align: top;
    }

    .s-info {
        display: inline-block;
    }

    .s-num-box {
        margin-top: 3px;
    }

    .s-num-unit {
        opacity: 0.7;
        font-size: 11px;
    }

    .s-num {
        font-family: BlackItalic;
        font-size: 35px;
        opacity: 1;
        letter-spacing: 3px;
        margin-right: 2px;
    }

    .s-sub-icon {
        width: 11px;
        vertical-align: top;
    }

    .s-sub {
        opacity: 0.6;
        margin-top: 5px;
        font-size: 11px;
    }

    .s-type {
        float: right;
        background-size: contain;
        width: 72px;
        height: 72px;
        margin-right: 5px;
    }

    .s-type-text {
        text-align: center;
        opacity: 0.6;
        margin-top: 30px;
        font-size: 14px;
        font-weight: 400;
    }

    .d-sport {
        width: 315px;
        height: 65px;
        background: var(--bg-color-1);
        margin: 0 auto;
        border-radius: 13px 13px 13px 13px;
        position: relative;
    }

    .d-sport-type {
        font-size: 15px;
        color: var(--text-color-1);
        position: absolute;
        top: 10px;
        left: 16px;

    }

    .d-desc-item {
        text-align: center;
        margin-bottom: 16px;
    }

    .d-desc-center {
        /*border-left: 1px solid #FFFFFF;*/
        position: relative;
    }

    .d-desc-center:before {
        content: '';
        position: absolute;
        left: 0;
        top: 35%;
        bottom: auto;
        right: auto;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .d-desc-center:after {
        content: '';
        position: absolute;
        left: auto;
        top: 35%;
        bottom: auto;
        right: 0;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .desc-num {
        font-family: Bold;
        font-size: 24px;
    }

    .desc-title {
        color: #A5A5A5;
        font-size: 11px;
    }

    .d-bottom {
        /*border-top: 1px solid #000000;*/
    }

    .d-b-item {
        text-align: center;
        font-size: 13px;
        line-height: 22px;
        margin-top: 6px;
        color: var(--text-color-1);
    }

    .d-b-icon {
        width: 22px;
        vertical-align: bottom;
    }

    .d-b-item-left {
        position: relative;
    }

    /*.d-b-item-left:after {*/
    /*    content: '';*/
    /*    position: absolute;*/
    /*    left: auto;*/
    /*    top: 13%;*/
    /*    bottom: auto;*/
    /*    right: 0;*/
    /*    height: 70%;*/
    /*    width: 1px;*/
    /*    background-color: #000000;*/
    /*}*/

    .ecg-info {
        position: relative;
    }

    .ecg-normal {
        width: 6px;
        height: 6px;
        background: #00BD9B;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-error {
        width: 6px;
        height: 6px;
        background: #FF0101;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-conclusion {
        display: inline-block;
        font-size: 15px;
        color: var(--text-color-1);
        margin-left: 25px;
        margin-top: 10px;
    }

    .ecg-from {
        color: #A5A5A5;
        font-size: 12px;
        margin-left: 15px;
        margin-top: 5px;
    }

    .ecg-add {
        font-weight: bold;
        color: var(--text-color-1) !important;
        margin: 0 2px;
    }

    .d-ecg-left {
        margin: 5px 0 15px 0;
    }

    .d-ecg {
        width: 315px;
        position: relative;
        background: var(--bg-color-1);
        border-radius: 10px 10px 10px 10px;
        margin: 0 auto;
    }

    .ecg-chart {
        position: absolute;
        right: 0;
        top: 0px;
        width: 150px;
        height: 73px;
    }

    .d-comment {
        border-radius: 10px 10px 10px 10px;
        border: 2px solid var(--text-color-1);
        margin: 6px 10px 6px 10px;
    }

    .d-comment-box {
        padding: 6px 12px;
    }

    .d-comment-item {
        color: rgba(0, 0, 0, 0.5);
        line-height: 26px;
        font-size: 14px;
    }

    .comment-avatar {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        vertical-align: middle;
    }

    .comment-comment {
        color: #999999;
    }

    .comment-username {
        color: var(--text-color-1);
    }

    .all-btn {
        color: #00BD9B;
        font-size: 12px;
        margin-left: 20px;
    }

    .friend-box {
        margin-top: 17px;
        margin-left: 20px;
        margin-bottom: 9px;
    }

    .own {
        display: inline-block;
        margin-right: 10px;
    }

    .own-icon {
        width: 40px;
        height: 40px;
        border: 2px solid rgba(32, 211, 143, 0.69);
        border-radius: 50%;
    }

    .friend {
        display: inline-block;
    }

    .friend-icon {
        width: 40px;
        height: 40px;
        border: 2px solid #707070;
        border-radius: 50%;
        margin-left: -6px;
    }

    .other-num {
        display: inline-block;
        color: var(--text-color-1);
        font-size: 19px;
        vertical-align: top;
        line-height: 42px;
    }

    .add-box {
        display: inline-block;
        float: right;
        margin-right: 15px;
    }

    .add-icon {
        width: 42px;
        height: 42px;
    }

    .rank-box {
        text-align: center;
    }

    .rank {
        width: 345px;
    }

    .target-box {
        width: 347px;
        margin: 0 auto;
        position: relative;
    }

    .target-bg {
        width: 100%;
    }

    .complete-num {
        position: absolute;
        font-family: SemiBoldItalic;
        font-size: 17px;
        top: 16px;
        right: 22px;
    }

    .c-num {
        color: var(--text-color-1);
        opacity: 0.9;
        margin-right: 2px;
    }

    .nc-num {
        color: var(--text-color-2);
        opacity: 0.6;
    }

    .step-num {
        position: absolute;
        font-family: SemiBoldItalic;
        font-size: 17px;
        top: 48px;
        right: 22px;
    }

    .st-num {
        color: #20D38F;
        margin-right: 2px;
    }

    .cal-num {
        position: absolute;
        font-family: SemiBoldItalic;
        font-size: 17px;
        top: 78px;
        right: 22px;
    }

    .ca-num {
        color: #FF7347;
        margin-right: 2px;
    }

    .progress {
        height: 12px;
        background: #E6E6E6;
        border-radius: 10px 10px 10px 10px;
        overflow: visible;
    }

    .progress-bar {
        float: left;
        width: 0;
        height: 100%;
        font-size: 12px;
        line-height: 20px;
        color: var(--bg-color-2);
        text-align: center;
    }

    .progress .progress-bar {
        border-radius: 20px;
        position: relative;
        /*animation: animate-positive 2s;*/
    }


    .progress-bar-striped {
        background-image: -webkit-linear-gradient(120deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
        background-image: -o-linear-gradient(120deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
        background-image: linear-gradient(120deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
        -webkit-background-size: 12px 20px;
        background-size: 12px 20px;
        z-index: 1;
    }

    .progress-bar-info {
        background: #00BD9B;
    }

    @-webkit-keyframes animate-positive {
        0% {
            width: 0;
        }
    }

    @keyframes animate-positive {
        0% {
            width: 0;
        }
    }

    .step-progress {
        position: absolute;
        left: 71px;
        top: 53px;
        width: 160px;
    }

    .cal-progress {
        position: absolute;
        left: 71px;
        top: 83px;
        width: 160px;
    }

    .progress-bar-info-cal {
        background: #FF7347;
    }

    .unread-box {
        background: var(--bg-color-2);
        border-radius: 4px 4px 4px 4px;
        width: 140px;
        position: relative;
        margin: 0 auto;
        height: 32px;
        color: var(--text-color-1);
    }

    .unread-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: absolute;
        top: 6px;
        left: 14px;
    }

    .unread-msg {
        position: absolute;
        font-size: 12px;
        top: 8px;
        left: 46px;
    }

    .unread-box-margin {
        margin-top: 3px;
        margin-bottom: 10px;
        text-align: center;
    }

    .qr-code {
        width: 22px;
        height: 22px;
        margin: 11px 0;
        float: right;
    }

    .banner-add {
        width: 22px;
        height: 22px;
        margin: 11px 15px 11px 10px;
        float: right;
    }

    .right-box {
        position: relative;
        width: 100%;
        height: 45px;
    }

    .new-bar {
        width: 4px;
        height: 4px;
        background: #E24160;
        opacity: 1;
        border-radius: 50%;
        position: absolute;
        right: 15px;
        top: 13px;
    }

    .apply-value {
        width: 345px;
        height: 44px;
        margin: 10px auto 10px;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        position: relative;
    }

    /deep/ input {
        background-color: var(--bg-color-1);
        color: #000000;
        font-size: 14px;
        caret-color: var(--chart-color-2);
        padding: 7px 10px;
        height: 28px;
        border-radius: 6px;
    }

    /deep/ input::-webkit-input-placeholder {
        color: var(--text-color-1);
        opacity: 0.2;
    }

    /deep/ input::-moz-placeholder {
        color: var(--text-color-1);
        opacity: 0.2;
    }

    /deep/ input:-moz-placeholder {
        color: var(--text-color-1);
        opacity: 0.2;
    }

    /deep/ input::-ms-input-placeholder {
        color: var(--text-color-1);
        opacity: 0.2;
    }

    /deep/ .van-cell {
        background-color: var(--bg-color-2) !important;
        border-radius: 6px;
        padding: 8px;
    }

    /deep/ .van-button--primary {
        background-color: #00BD9B;
        border-radius: 6px;
        font-size: 14px;
        padding: 7px;
        height: 28px;
        border-color: #00BD9B;
    }

    .load-more {
        text-align: center;
        font-size: 14px;
        margin: 0 auto 10px;
    }

    .content-body {
        color: var(--text-color-1);
    }

    .d-sport-info {
        font-family: PP;
        font-size: 19px;
        position: relative;
        top: 30px;
        left: 16px;
        display: flex;
        align-items: center;
    }

    .d-unit {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.5);
        margin-left: 4px;
        vertical-align: middle;
    }

    .d-sport-time {
        width: 17px;
        margin-left: 12px;
        margin-right: 4px;
        vertical-align: middle;
    }

    .d-sport-icon {
        width: 30px;
        position: absolute;
        right: 21px;
        top: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/01home.vue